import React from 'react';

function CheckCircleSolid(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.5898 8.13169C16.3139 7.92436 15.9221 7.98 15.7147 8.25598L10.476 15.2289L8.12361 12.5234L8.05091 12.4523C7.81949 12.26 7.47629 12.258 7.24187 12.4619C6.9814 12.6884 6.95386 13.0832 7.18037 13.3436L9.63442 16.1657L9.72622 16.2597C10.1424 16.6393 10.7862 16.655 11.2216 16.2764C11.2812 16.2245 11.3353 16.1664 11.3828 16.1032L16.7141 9.00679L16.7685 8.92083C16.9081 8.6543 16.8382 8.31829 16.5898 8.13169Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default CheckCircleSolid;
